import { createFileRoute } from '@tanstack/react-router'
import Screen from './-components/screen'

export const Route = createFileRoute('/(inventory)/branch/_layout/automations/')({
  component: Screen
})